import {ImagePreview, Dialog, Toast} from 'vant'
import {complete,locationTo,baseURL} from '@/utils/url'
import http from "@/utils/http"

/*预定义文件类型*/
export const FILE_TYPE_IMAGE = 'FILE_TYPE_IMAGE'
export const FILE_TYPE_TEXT = 'FILE_TYPE_TEXT'
export const FILE_TYPE_PDF = 'FILE_TYPE_PDF'
export const FILE_TYPE_WORD = 'FILE_TYPE_WORD'
export const FILE_TYPE_EXCEL = 'FILE_TYPE_EXCEL'
export const FILE_TYPE_PPT = 'FILE_TYPE_PPT'
export const FILE_TYPE_AUDIO = 'FILE_TYPE_AUDIO'
export const FILE_TYPE_VIDEO = 'FILE_TYPE_VIDEO'
export const FILE_TYPE_ZIP = 'FILE_TYPE_ZIP'
export const FILE_TYPE_OTHER = 'FILE_TYPE_OTHER'

/*消息ID*/
export const MESSAGE_ID_DEFAULT = MESSAGE_ID_SERVICEHALL
export const MESSAGE_ID_SERVICEHALL = 'SERVICE_HALL'

/*文件相关方法*/
export const parseFileType = _parseFileType
export const previewFile = _previewFile
export const previewImage = _previewImage
export const sendFile = _sendFile

/**
 * 解析文件类型
 * @param fileType
 * @returns {string}
 * @private
 */
function _parseFileType(fileType) {
    if (/^(bmp|jpg|tiff|gif|pcx|tga|exif|fpx|svg|psd|cdr|pcd|dxf|ufo|eps|ai|raw|png|jpeg)$/i.test(fileType)) return FILE_TYPE_IMAGE
    else if (/^(txt|html|htm|js|java|css)$/i.test(fileType)) return FILE_TYPE_TEXT
    else if (/^(pdf|hlp)$/i.test(fileType)) return FILE_TYPE_PDF
    else if (/^(doc|docx)$/i.test(fileType)) return FILE_TYPE_WORD
    else if (/^(xls|xlsx|et|ett|xlt)$/i.test(fileType)) return FILE_TYPE_EXCEL
    else if (/^(ppt|pptx|pps|pot|dpt|dps)$/i.test(fileType)) return FILE_TYPE_PPT
    else if (/^(wav|aif|au|mp3|ram)$/i.test(fileType)) return FILE_TYPE_AUDIO
    else if (/^(avi|mpg|mov|swf|mpeg|3gp|flv|f4v|rm|rmvb|wmv|ogg|webm|mp4)$/i.test(fileType)) return FILE_TYPE_VIDEO
    else if (/^(rar|zip|arj|gz|z|7z)$/i.test(fileType)) return FILE_TYPE_ZIP
    else return FILE_TYPE_OTHER
}

/**
 * 预览文件，目前支持图片、pdf、office，其它文件直接用浏览器打开
 * @param fileType
 * @param url
 * @private
 */
function _previewFile(fileType, url) {
    switch (fileType) {
        case FILE_TYPE_IMAGE:
            _previewImage([complete(url)])
            break
        case FILE_TYPE_PDF:
            locationTo("weixin/weui/lib/pdfjs/pdfjs-2.1.266-dist/web/viewer.html?file=" + encodeURIComponent(complete(url, true)))
            break
        case FILE_TYPE_WORD:
        case FILE_TYPE_EXCEL:
        case FILE_TYPE_PPT:
            var targetPath = url.replace('downloadfile','convertfile/mobile');
            http.get(targetPath,{}).then(res => {
                if(res && res.code != "200"){
                    Toast(res.message)
                    return false
                }
                if(res.data.indexOf(".pdf") != -1){
                    locationTo("weixin/weui/lib/pdfjs/pdfjs-2.1.266-dist/web/viewer.html?file="
                        + encodeURIComponent(res.data + "&mode=inline"))
                }else{
                    locationTo(res.data)
                }
            }).catch(err => {
                Toast(err.message || '下载失败')
            })
            break
        default:
            locationTo.href(complete(url, true))
            break
    }
}

/**
 * 预览图片（vant）
 * @param images
 * @param startPosition
 * @private
 */
function _previewImage(images, startPosition = 0) {
    ImagePreview({
        images: images,
        startPosition: startPosition,
    })
}

/**
 * 发送文件给我（微信、钉钉）
 * @param fileType
 * @param fileSize
 * @param url
 * @private
 */
function _sendFile(fileType, fileSize, url, messageId = MESSAGE_ID_DEFAULT) {
    // 检查客户端
    if (!env.wechat && !env.dingtalk) return Toast( '暂时只支持企业微信、钉钉客户端')

    // 检查文件大小
    const MB = 1024 * 1024
    if (env.wechat) {
        // 图片2MB、音频5MB、视频10MB、其它20MB
        if (fileType == FILE_TYPE_IMAGE && fileSize > 2 * MB
            || fileType == FILE_TYPE_AUDIO && fileSize > 5 * MB
            || fileType == FILE_TYPE_VIDEO && fileSize > 10 * MB
            || fileType > 20 * MB) {
            return Toast('文件大小超出微信接口限制(图片2MB、音频5MB、视频10MB、其它20MB)')
        }
    } else if (env.dingtalk) {
        // 图片1MB、音频2MB、其它10MB
        if (fileType == FILE_TYPE_IMAGE && fileSize > 1 * MB
            || fileType == FILE_TYPE_AUDIO && fileSize > 2 * MB
            || fileType > 10 * MB) {
            return Toast('文件大小超出钉钉接口限制(图片1MB、音频2MB、其它10MB)')
        }
    }

    // 发送文件
    http.post('/media/uploadSendToMe.htm', {serverPath: url, source: messageId})
        .then(resp => {
            if (resp.code == '200') Toast('发送命令执行成功，为您推送文件可能会花几分钟时间')
            else Toast('文件发送失败，请稍后重试')
        })
        .catch(() => {
            Toast('文件发送失败，请稍后重试')
        })
}
